import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { isOnlineOnlyRestricted } from "@faire/retailer-visitor-shared/lib/brandRestrictionUtils";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useRetailerBusinessCategory } from "@faire/retailer-visitor-shared/views/underwriting-request/useRetailerBusinessCategory";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { useMemo } from "react";

export const useCanAddToCart = (
  brand?: Pick<IBrand, "forbids_online_only_retailers">
): boolean => {
  const { retailer } = useRetailer();
  const { isOnlineOnlyRetailer } = useRetailerBusinessCategory();

  const shouldAddToCart = useMemo(
    () =>
      !!retailer &&
      !getIsBrandPreview() &&
      !isOnlineOnlyRestricted(brand, isOnlineOnlyRetailer),
    [brand, retailer, isOnlineOnlyRetailer]
  );

  return shouldAddToCart;
};
